import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface ButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void | Promise<void>;
  href?: string;
  icon?: IconDefinition;
  secondary_style?: boolean;
  className?: string;
}

export default function Button({
  children,
  disabled = false,
  onClick,
  href,
  icon,
  secondary_style,
  className: additional_class = "",
}: ButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (!onClick || isLoading || disabled) return;

    const result = onClick();
    if (result instanceof Promise) {
      setIsLoading(true);
      try {
        await result;
      } finally {
        setIsLoading(false);
      }
    }
  };

  const className = `select-none cta w-full text-center rounded-[4px] flex items-center justify-center gap-[12px] ${secondary_style ? "text-primary p-[1px] py-[1px]" : "hover:opacity-80 py-[16px] text-surface"} ${additional_class}`;
  const isDisabled = disabled || isLoading;

  const gradientStyle = {
    background:
          "linear-gradient(185deg, var(--color-brand-1) 0%, var(--color-brand-2) 39%, var(--color-brand-3) 91.67%)",
        boxShadow: "0 1px 0 0 rgba(255, 255, 255, 0.50) inset",
  };
  
  const content = (
    <>
      {icon && <FontAwesomeIcon icon={icon} className="cta" />}
      <span className="cta">{children}</span>
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        className={`${className} ${isDisabled ? "pointer-events-none opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
        style={gradientStyle}
      >
        {secondary_style ? <>
        <div className="bg-surface w-full h-full py-[15px] px-[3px] rounded-[4px] hover:bg-white/5 hover:text-surface">
          {content}
        </div>
        </> : <>
        {content}
        </>}
      </a>
    );
  }

  return (
    <div
      onClick={() => {
        if (!isDisabled) {
          handleClick();
        }
      }}
      className={`${className} ${isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
      style={gradientStyle}
    >
      {secondary_style ? <>
        <div className="bg-surface w-full h-full py-[15px] px-[3px] rounded-[4px] hover:bg-white/5 hover:text-surface">
          {content}
        </div>
        </> : <>
        {content}
        </>}
    </div>
  );
}


